import { db } from "../firebase";
import {
  collection,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";

// Get all trades for a user
export const getUserTrades = async (userId) => {
  try {
    console.log("Getting trades for userId:", userId); // Debug log
    const tradesRef = collection(db, "trades");
    const q = query(
      tradesRef,
      where("userId", "==", userId),
      orderBy("date", "desc")
    );

    const querySnapshot = await getDocs(q);
    const trades = [];
    querySnapshot.forEach((doc) => {
      trades.push({ id: doc.id, ...doc.data() });
    });

    console.log("Retrieved trades:", trades); // Debug log
    return trades;
  } catch (error) {
    console.error("Error getting trades:", error);
    throw error;
  }
};

// Save new trades (for CSV imports)
export const saveTradesToFirestore = async (userId, trades, broker) => {
  try {
    const existingTrades = await getUserTrades(userId);

    // Create unique identifiers for existing trades
    const existingTradeIds = new Set(
      existingTrades.map(
        (trade) =>
          `${trade.date}-${trade.symbol}-${trade.entryPrice}-${trade.exitPrice}-${trade.quantity}`
      )
    );

    // Filter out duplicates
    const newTrades = trades.filter((trade) => {
      const tradeId = `${trade.date}-${trade.symbol}-${trade.entryPrice}-${trade.exitPrice}-${trade.quantity}`;
      return !existingTradeIds.has(tradeId);
    });

    // Save new trades
    const batch = [];
    for (const trade of newTrades) {
      const tradeData = {
        userId,
        broker,
        ...trade,
        timestamp: serverTimestamp(),
      };
      batch.push(addDoc(collection(db, "trades"), tradeData));
    }

    if (batch.length > 0) {
      await Promise.all(batch);
      return true;
    }

    return false;
  } catch (error) {
    console.error("Error saving trades:", error);
    throw error;
  }
};

// Update trade details (for tags, notes, etc.)
export const updateTradeDetails = async (tradeId, updates) => {
  try {
    const tradeRef = doc(db, "trades", tradeId);
    await updateDoc(tradeRef, {
      ...updates,
      lastUpdated: serverTimestamp(),
    });
    return true;
  } catch (error) {
    console.error("Error updating trade:", error);
    throw error;
  }
};

export const getLatestAccountBalance = async (userId) => {
  try {
    const balanceRef = doc(db, "accountBalances", userId);
    const balanceDoc = await balanceRef.get();

    if (balanceDoc.exists()) {
      return balanceDoc.data().balance;
    }
    return 0;
  } catch (error) {
    console.error("Error getting account balance:", error);
    return 0;
  }
};
